export default "__VITE_ASSET__DcpABoFg__"